import * as actions from './actions';


export default (state = {}, action) => {
  switch (action.type) {
    case actions.INIT.END:
      return {
        ...action.selectedValue,
        columnOptions: action.columnOptions,
        highlights: {},
      };
    case actions.SET_NAME:
      return {
        ...state,
        value: {
          ...state.value,
          name: action.name,
        },
      };
    case actions.SET_IS_ACTIVE:
      return {
        ...state,
        value: {
          ...state.value,
          isActive: action.value,
        },
      };
    case actions.SET_ORDER:
      return {
        ...state,
        value: {
          ...state.value,
          order: action.order,
        },
      };
    case actions.SET_IS_SPRINT_BOARD:
      return {
        ...state,
        value: {
          ...state.value,
          isSprintedBoard: action.value,
        },
      };
    case actions.SET_TIMELINE_TYPE:
      return {
        ...state,
        timelineType: action.value,
        value: {
          ...state.value,
          isTTColorsCategoryBased: action.value === 1,
        },
      };
    case actions.SET_IS_GROUPED_BOARD.END:
      return {
        ...state,
        isGroupedBoard: !!(action.columns.length && action.columns[0].isGrouped),
        columnOptions: action.columnOptions,
        value: {
          ...state.value,
          columns: action.columns,
        },
      };
    case actions.REMOVE_COLUMN.END:
    case actions.ADD_COLUMN.END:
    case actions.REMOVE_ROW.END:
    case actions.ADD_ROW.END:
    case actions.SET_COLUMN_NAME.END:
      return {
        ...state,
        highlights: action.highlights || {},
        columnOptions: action.columnOptions,
        value: {
          ...state.value,
          columns: action.columnOptions.map(x => x.value),
        },
      };
    case actions.SET_STATYS.END:
    case actions.SET_ITEM_TYPE.END:
      return {
        ...state,
        highlights: action.highlights,
        columnOptions: action.columnOptions,
        value: {
          ...state.value,
          columns: action.columnOptions.map(x => x.value),
        },
      };
    case actions.RESET_HIGHLIGHTS:
      return {
        ...state,
        highlights: {},
      };
    case actions.SET_GROUP_ITEM_TYPE.END:
      return {
        ...state,
        columnOptions: action.columnOptions,
        value: {
          ...state.value,
          columns: action.columnOptions.map(x => x.value),
        },
      };
    case actions.SET_REMOVED:
      return {
        ...state,
        value: {
          ...state.value,
          isRemoved: action.value,
        },
      };
    case actions.INVALIDATE_CHANGES:
      return {
        ...state,
        changes: action.changes,
      };
    case actions.CHECK_VALIDATION.END:
      return {
        ...state,
        errors: action.errors,
      };
    case actions.EMPTY:
      return {};
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/board/currentBoard/reducer.js